export const bellSchedules = {
    'Schedule A': [
        { period: 'Period 1', start: '8:30', end: '9:20' },
        { period: 'Period 2', start: '9:27', end: '10:17' },
        { period: 'Brunch', start: '10:17', end: '10:25' },
        { period: 'Period 3', start: '10:32', end: '11:22' },
        { period: 'Period 4', start: '11:29', end: '12:19' },
        { period: 'Lunch', start: '12:19', end: '12:54' },
        { period: 'Period 5', start: '1:01', end: '1:51' },
        { period: 'Period 6', start: '1:58', end: '2:48' },
        { period: 'Period 7', start: '2:55', end: '3:45' }
    ],
    'Schedule B': [
        { period: 'Period 1', start: '8:30', end: '10:00' },
        { period: 'Brunch', start: '10:00', end: '10:08' },
        { period: 'Period 3', start: '10:15', end: '11:45' },
        { period: 'Lunch', start: '11:45', end: '12:25' },
        { period: 'Period 5', start: '12:32', end: '2:02' },
        { period: 'Period 7', start: '2:09', end: '3:39' }
    ],
    'Schedule C': [
        { period: 'Period 2', start: '8:30', end: '10:00' },
        { period: 'Tutorial', start: '10:07', end: '11:00' },
        { period: 'Brunch', start: '11:00', end: '11:08' },
        { period: 'Period 4', start: '11:15', end: '12:45' },
        { period: 'Lunch', start: '12:45', end: '1:25' },
        { period: 'Period 6', start: '1:32', end: '3:02' }
    ],
    'Schedule D': [
        { period: 'Period 1', start: '8:30', end: '9:30' },
        { period: 'Period 3', start: '9:37', end: '10:37' },
        { period: 'Brunch', start: '10:37', end: '10:45' },
        { period: 'Period 5', start: '10:52', end: '11:52' },
        { period: 'Period 7', start: '11:59', end: '12:59' },
        { period: 'Lunch', start: '12:59', end: '1:40' }
    ],
    'Schedule E': [
        { period: 'Period 2', start: '8:30', end: '9:30' },
        { period: 'Tutorial', start: '9:37', end: '10:20' },
        { period: 'Brunch', start: '10:20', end: '10:28' },
        { period: 'Period 4', start: '10:35', end: '11:35' },
        { period: 'Period 6', start: '11:42', end: '12:42' },
        { period: 'Lunch', start: '12:42', end: '1:25' }
    ],
    'Schedule G': [
        { period: 'Period 1', start: '8:30', end: '9:13' },
        { period: 'Period 2A', start: '9:20', end: '10:03' },
        { period: 'Period 2B', start: '10:10', end: '10:53' },
        { period: 'Brunch', start: '10:53', end: '11:01' },
        { period: 'Period 3', start: '11:08', end: '11:51' },
        { period: 'Period 4', start: '11:58', end: '12:41' },
        { period: 'Lunch', start: '12:41', end: '1:16' },
        { period: 'Period 5', start: '1:23', end: '2:06' },
        { period: 'Period 6', start: '2:13', end: '2:56' },
        { period: 'Period 7', start: '3:03', end: '3:46' }
    ],
    'Schedule H': [
        { period: 'Period 1', start: '10:30', end: '11:30' },
        { period: 'Period 3', start: '11:37', end: '12:37' },
        { period: 'Lunch', start: '12:37', end: '1:12' },
        { period: 'Period 5', start: '1:19', end: '2:19' },
        { period: 'Period 7', start: '2:26', end: '3:26' }
    ],
    'Schedule I': [
        { period: 'Period 2', start: '10:30', end: '11:30' },
        { period: 'Lunch', start: '11:30', end: '12:05' },
        { period: 'Period 4', start: '12:12', end: '1:12' },
        { period: 'Tutorial', start: '1:19', end: '2:02' },
        { period: 'Period 6', start: '2:09', end: '3:09' }
    ],
    // Special Testing Schedules
    'PSAT/SAT Testing': [
        { period: 'Report to Testing', start: '8:00', end: '8:30' },
        { period: 'Testing', start: '8:30', end: '12:30' },
        { period: 'Lunch Distribution', start: '12:30', end: '1:15' }
    ],
    'SBAC/CAASPP Testing': [
        { period: 'Testing', start: '8:30', end: '3:45' }
    ],
    'Finals - Day 1': [
        { period: 'Period 1', start: '8:30', end: '10:30' },
        { period: 'Break', start: '10:30', end: '10:43' },
        { period: 'Period 6', start: '10:50', end: '12:50' },
        { period: 'Lunch', start: '12:50', end: '1:30' },
        { period: 'Period 7', start: '1:37', end: '3:37' }
    ],
    'Finals - Day 2': [
        { period: 'Period 2', start: '8:30', end: '10:30' },
        { period: 'Break', start: '10:30', end: '10:43' },
        { period: 'Period 5', start: '10:50', end: '12:50' },
        { period: 'Enrichment', start: '12:50', end: '1:50' }
    ],
    'Finals - Day 3': [
        { period: 'Period 3', start: '8:30', end: '10:30' },
        { period: 'Break', start: '10:30', end: '10:43' },
        { period: 'Period 4', start: '10:50', end: '12:50' },
        { period: 'Enrichment', start: '12:50', end: '1:50' }
    ]
};

export const getBellSchedule = (scheduleType) => {
    if (!scheduleType) return null;

    // Check each schedule type to see if it's contained in scheduleType
    for (const [key, schedule] of Object.entries(bellSchedules)) {
        if (scheduleType.includes(key)) {
            return schedule;
        }
    }

    return null;
};


// Get current period based on time
export const getCurrentPeriod = (schedule) => {
    if (!schedule) return null;

    const now = new Date();
    const currentTime = now.getHours() * 60 + now.getMinutes(); // Convert to minutes

    for (const period of schedule) {
        const [startHour, startMin] = period.start.split(':').map(Number);
        const [endHour, endMin] = period.end.split(':').map(Number);

        const startTime = startHour * 60 + startMin;
        const endTime = endHour * 60 + endMin;

        if (currentTime >= startTime && currentTime < endTime) {
            return period;
        }
    }

    return null;
};